/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * zr-price component
 */

@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-theme/functions/fonts.scss" as f;
@use "../zr-theme/fonts/open-sans.scss";
@use "../zr-theme/fonts/museo-sans-rounded.scss";

// component name
$component: 'zr-price';

// component vars defaults
:host {
    --zr-price-font-size: var(--ci-font-size-px);
    --zr-current-price-font-size: 26px;
    --zr-current-price-line-height: 32px;
    --zr-recommended-price-font-size: 14px;
    --zr-recommended-price-line-height: 20px;
    --zr-current-price-per-unit-font-size: 14px;
    --zr-current-price-per-unit-line-height: 20px;

    @media only screen and (min-width: $tablet-screen) {
        --zr-current-price-font-size: 36px;
        --zr-current-price-per-unit-font-size: 16px;
        --zr-current-price-per-unit-line-height: 22px;
    }

    display: block;
    font-size: var(--zr-price-font-size);
}

.#{$component}__recommended-price,
.#{$component}__current-price,
.#{$component}__price-per-unit {
    margin: 0;
}

.#{$component}__recommended-price {
    font-family: 'Open Sans', sans-serif;
    font-size: var(--zr-recommended-price-font-size);
    line-height: var(--zr-recommended-price-line-height);
    color: #727272;
    font-weight: 300;
    margin-bottom: 3px;

    span {
        display: inline-block;
    }
}

%#{$component}__current-price {
    font-family: 'Museo Sans Rounded', sans-serif;
    font-size: var(--zr-current-price-font-size);
    color: var(--ci-neutral800);
    font-weight: 700;
    line-height: var(--zr-current-price-line-height);
    margin-bottom: 3px;
}

.#{$component}__current-price{
    @extend %#{$component}__current-price;
}

.#{$component}__highlight {
    .#{$component}__current-price{
        transition: color .2s ease;
        color: var(--ci-primary400);
    }
}

.#{$component}__current-price--wo-price-per-unit{
    @extend %#{$component}__current-price;
    margin-bottom: 20px;
}

.#{$component}__price-per-unit {
    font-family: 'Open Sans', sans-serif;
    font-size: var(--zr-current-price-per-unit-font-size);
    line-height: var(--zr-current-price-per-unit-line-height);
    color: var(--ci-neutral800);
    font-weight: 400;
}

